<div class="upload-queue-popup" *ngIf="((queue$ | async)?.length > 0 || (isPreparing$ | async)) && (isVisible$ | async)"  @slideUp>
    <mat-expansion-panel
        #uploaderPanel
        [expanded]="true"
        class="fm-uploader-panel"
        (closed)="panelOpenState = false"
        (opened)="panelOpenState = true"
        hideToggle>

        <!-- Header -->
        <mat-expansion-panel-header
            collapsedHeight="56"
            expandedHeight="56"
            class="bg-primary-500">
            <mat-panel-title class="text-white upload-queue-title">
                {{ (isPreparing$ | async) && (queue$ | async)?.length === 0 ? 'Preparing files…' : (queueHeader$ | async) }}
            </mat-panel-title>
            <mat-panel-description class="custom-close-expanded-align-end">
                <button
                    mat-icon-button
                    [matTooltip]="panelOpenState ? 'Minimize' : 'Expand'"
                    (click)="togglePanel(uploaderPanel, $event)">
                    <mat-icon class="icon-size-4 text-white"
                        [svgIcon]="uploaderPanel.expanded ? 'mat_outline:expand_more' : 'mat_outline:expand_less'">
                    </mat-icon>
                </button>
                <button
                    mat-icon-button
                    matTooltip="Close"
                    (click)="onCloseClick($event)">
                    <mat-icon class="icon-size-4 text-white" svgIcon="feather:x"></mat-icon>
                </button>
            </mat-panel-description>
        </mat-expansion-panel-header>

        <!-- Queue list -->
        <div
            class="uploader-queue-scroll flex-0 h-full overflow-y-auto overscroll-y-contain sm:overflow-hidden sm:overscroll-auto"
            fuseScrollbar
            [fuseScrollbarOptions]="{ wheelPropagation: false }">
            <div *ngIf="(isPreparing$ | async) && (queue$ | async)?.length === 0"
                class="flex items-center gap-3 px-4 py-6">
                <mat-spinner diameter="20"></mat-spinner>
                <span class="text-sm text-gray-600 dark:text-gray-300">Getting your files ready&hellip;</span>
            </div>
            <div class="uploader-queue-list col">
                <ng-container *ngFor="let file of queue$ | async">
                    <div class="uploader-queue-list-item">
                        <div class="flex items-center w-full gap-2 py-1">
    
                            <!-- File name -->
                            <div class="flex-1 min-w-0">
                                <span class="upload-item-name">
                                    {{ file.file.name }}
                                </span>
                            </div>
                        
                            <!-- Progress -->
                            <div class="flex-shrink-0 w-10 text-right">
                                <span class="text-xs font-mono text-gray-500 dark:text-gray-400">
                                    {{ getProgress(file) }}%
                                </span>
                            </div>
                        
                            <!-- Status icon -->
                            <div class="flex-shrink-0 flex items-center justify-center w-6 h-6">
                                <mat-icon
                                    [title]="file.isUploading ? 'Uploading' : (file?.some?.title ?? '')"
                                    [svgIcon]="getIcon(file)"
                                    [ngClass]="getIconColor(file)"
                                    class="icon-size-4">
                                </mat-icon>
                            </div>

                            <!-- Cancel / Remove button -->
                            <div class="flex-shrink-0 flex items-center justify-center w-6 h-6">
                                <button
                                    mat-icon-button
                                    color="primary"
                                    style="width:24px;height:24px;line-height:24px;"
                                    [matTooltip]="(file.isUploading && !file.isError) ? 'Cancel' : 'Remove'"
                                    (click)="(file.isUploading && !file.isError) ? cancelFile(file) : removeFile(file)">
                                    <mat-icon class="icon-size-4" svgIcon="feather:x"></mat-icon>
                                </button>
                            </div>
                        
                        </div>
                        <div>
                            <mat-progress-bar
                                *ngIf="!file.isError"
                                [mode]="(file.progress === 100 && file.isUploading) ? 'indeterminate' : 'determinate'"
                                [value]="getProgress(file)">
                            </mat-progress-bar>
                        </div>
                    </div>
                    <mat-divider class="divider-queue-item"></mat-divider>
                </ng-container>
            </div>
        </div>

    </mat-expansion-panel>
</div>
